export const ATTACHMENT_ELEMENT = "attachment" as const;
